import {ICalendarDate} from "../types/ICalendarDate";

export const getDaysArray = (daysNumber: number, startingDate?: Date): ICalendarDate[] => {
    const date = startingDate || new Date();
    const days: ICalendarDate[] = [];
    for (let i = 0; i < daysNumber; i++) {
        days.push({day: date.getDate(), month: date.getMonth(), year: date.getFullYear(), dayId: date.getDay(), hour: undefined});
        date.setDate(date.getDate() + 1);
    }
    return days;
};
import {ICalendarDate} from "../types/ICalendarDate";

export const getDaysArray = (daysNumber: number, startingDate?: Date): ICalendarDate[] => {
    const date = startingDate || new Date();
    const days: ICalendarDate[] = [];
    for (let i = 0; i < daysNumber; i++) {
        days.push({day: date.getDate(), month: date.getMonth(), year: date.getFullYear(), dayId: date.getDay(), hour: undefined});
        date.setDate(date.getDate() + 1);
    }
    return days;
};
